import type { BrandConfiguration } from "./types";

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const BRAND_CONFIGURATION: BrandConfiguration = require(
  `./${process.env.BRAND}`,
).default;

export type { BrandConfiguration };
